const pageSizes = [
  25,
  50,
  100,
];

export default pageSizes;



// WEBPACK FOOTER //
// ./src/constants/pageSizes.js